import React, { Fragment, Component } from 'react'
import * as R from 'ramda'

import { unescapeHtmlTags } from '../../../../helpers'

class GroupedRows extends Component {
    constructor(props) {
        super(props)

        this.setGroupedOptions()
    }

    setGroupedOptions = () => {
        const { question } = this.props
        const { options } = question.optionSetY
            ? question.optionSetY
            : question.optionSet

        this.groupedOptions = options.reduce((group, { id, headerGroupId }) => {
            if (!R.hasIn(headerGroupId, group)) {
                group[headerGroupId] = new Set()
            }
            group[headerGroupId].add(id)
            return group
        }, {})
    }

    getTitle = (headerGroup) => {
        const { question, store, reportStore } = this.props

        if (!headerGroup) return ''

        const { survey } = store
        const { locale } = reportStore
        const { defaultLocale } = survey.metadata
        const { initialLocale } = question.metadata
        const { title } = headerGroup

        let text = ''
        if (title[locale]) {
            text = title[locale]
        } else if (title[defaultLocale]) {
            text = title[defaultLocale]
        } else if (title[initialLocale]) {
            text = title[initialLocale]
        }

        return unescapeHtmlTags(text)
    }

    render() {
        const { question, renderRows, cols } = this.props
        const { headerGroups } = question

        const rows = headerGroups.map((headerGroup) => {
            const optionRows = renderRows(cols, this.groupedOptions[headerGroup.id])

            const hasRows = (
                !(Array.isArray(optionRows))
                || optionRows.some((o) => !R.isNil(o))
            )

            if (!hasRows) return null

            return (
                <Fragment>
                    <tr className="col groupedHeader">
                        <th>
                            <div>
                                {this.getTitle(headerGroup)}
                            </div>
                        </th>
                        {cols.map((_, i) => (i === cols.length - 1 ? <td className="tlast" /> : <td />))}
                    </tr>
                    {optionRows}
                </Fragment>
            )
        })

        if (this.groupedOptions[undefined]) {
            rows.push(
                <Fragment>
                    <tr className="col">
                        <th>
                            <h3
                                style={{
                                    fontSize: '18px',
                                    fontWeight: 600,
                                    textDecoration: 'underline',

                                }}
                            >
                                {this.getTitle()}
                            </h3>
                        </th>
                        <td />
                        <td className="tlast" />
                    </tr>
                    {renderRows(cols, this.groupedOptions[undefined])}
                </Fragment>,
            )
        }

        return rows
    }
}

export default GroupedRows
